import { useState, useEffect, useContext } from "react";
import "./Settings.css";
import ProfileDetailsPage from "./ProfileDetails";
import MembersPage from "./Member";
import SubscriptionsPage from "./Subscription-Pages/Subscription";
import AppearancePage from "./Appearance";
import IntegrationPage from "./Integration";
import PublicCareerPortal from "./PublicCareerPortal";
import PublicportLightIcon from "../../Assets/Images/public-port-light.svg";
import PublicportActiveIcon from "../../Assets/Images/public-port-active.svg";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowIcon from "../../Assets/Images/arrow-right.png";
import { ReactComponent as ProfileIcon } from "../../Assets/Images/profile-icon.svg";
import ProfileDarkIcon from "../../Assets/Images/profile-dark-icon.svg";
import { ReactComponent as MembersIcon } from "../../Assets/Images/member-icon.svg";
import MembersDarkIcon from "../../Assets/Images/member-dark-icon.svg";
import { ReactComponent as SubscriptionsIcon } from "../../Assets/Images/subscription-icon.svg";
import SubscriptionsDarkIcon from "../../Assets/Images/subscription-dark-icon.svg";
import { ReactComponent as ProfileActiveIcon } from "../../Assets/Images/profile-active-icon.svg";
import { ReactComponent as MembersActiveIcon } from "../../Assets/Images/member-active-icon.svg";
import { ReactComponent as SubscriptionsActiveIcon } from "../../Assets/Images/subscription-active-icon.svg";
import { ReactComponent as AppearanceActiveIcon } from "../../Assets/Images/appearance-active-icon.svg";
import AppearanceDarkIcon from "../../Assets/Images/appearance-dark-icon.svg";
import { ReactComponent as AppearanceIcon } from "../../Assets/Images/appearance-icon.svg";
import { ReactComponent as IntegrationActiveIcon } from "../../Assets/Images/customfields-icon-light-active.svg";
import integrationDarkIcon from "../../Assets/Images/customfields-icon-dark.svg";
import { ReactComponent as IntegrationIcon } from "../../Assets/Images/customfields-icon-light-inactive.svg";
import { ReactComponent as FeedbackIcon } from "../../Assets/Images/feedback-black-outline.svg";
import feedbackDarkIcon from "../../Assets/Images/feedback-white-outline.svg";
import FeedbackActiveIcon from "../../Assets/Images/feedback-icon.png";
import { DynamicContext } from "../../Context/DynamicContext";
import SettingsIcon from "../../Assets/Images/mingcute_settings-1-line.svg";
import SettingsDarkIcon from "../../Assets/Images/settings-dark.svg";
import FeedbackList from "./Feedback-Pages/FeedBackList";
import PortalIntegrations from "./PortalIntegrations";
import { ReactComponent as InvoiceConfigDark} from "../../Assets/Images/invoice-config-dark.svg";
import { ReactComponent as InvoiceDarkIcon } from "../../Assets/Images/invoice-config-icon-dark.svg";
import { ReactComponent as InvoiceLightIcon } from "../../Assets/Images/invoice-config-icon-light.svg";
import { ReactComponent as PortalIntegrationIcon } from "../../Assets/Images/portal-integrations-icon-inactive.svg";
import { ReactComponent as PortalIntegrationActiveIcon } from "../../Assets/Images/portal-integrations-icon-active.svg";
import { ReactComponent as PortalIntegrationDarkIcon } from "../../Assets/Images/portal-integrations-icon-dark.svg";
import InvoiceConfiguration from "./Invoice-Config-Pages/InvoiceConfiguration";

function Settings() {
  const {
    isDarkMode,
    hasSubscription,
    AdminAccess,
    isVendorFeatureEnabled,
    SuperAdminAccess,
    subscriptionDetails,
    isHiringTeamTenant
  } = useContext(DynamicContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("Profile");

  const validSubscriptionStatuses = ["active", "trialing"];
  const hasValidSubscriptionStatus = validSubscriptionStatuses.includes(
    subscriptionDetails?.status
  );
  const alwaysAllowedTabs = ["Profile", "Subscriptions", "Appearance"];

  const hasUserPageAccess = AdminAccess || SuperAdminAccess;

  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);

  const renderContent = () => {
    if (!hasValidSubscriptionStatus && !alwaysAllowedTabs.includes(activeTab)) {
      return <ProfileDetailsPage />;
    }
    switch (activeTab) {
      case "Profile":
        return <ProfileDetailsPage />;
      case "Users":
        return <MembersPage />;
      case "Subscriptions":
        return (
          <SubscriptionsPage
            initialTab={location.state?.activeTab ? "Plan Details" : "Billings"}
          />
        );
      case "Appearance":
        return <AppearancePage />;
      case "Customizations":
        return <IntegrationPage />;
      case "Feedback List":
        return <FeedbackList />;
      case "Career Portal":
        return <PublicCareerPortal />;
      case "Portal Integration":
        return <PortalIntegrations />;
      case "Invoice Configuration":
        return <InvoiceConfiguration />; 
      default:
        return <ProfileDetailsPage />;
    }
  };

  useEffect(() => {
    const path = location.pathname;
    let resolvedTab = "Profile";
    if (path.includes("/settings/users")) resolvedTab = "Users";
    else if (path.includes("/settings/profile")) resolvedTab = "Profile";
    else if (path.includes("/settings/subscriptions"))
      resolvedTab = "Subscriptions";
    else if (path.includes("/settings/appearance")) resolvedTab = "Appearance";
    else if (path.includes("/settings/customizations"))
      resolvedTab = "Customizations";
    else if (path.includes("/settings/feedback-list"))
      resolvedTab = "Feedback List";
    else if (path.includes("/settings/career-portal"))
      resolvedTab = "Career Portal";
    else if (path.includes("/settings/portal-integration"))
      resolvedTab = "Portal Integration";
    else if (path.includes("/settings/invoice-configuration"))
      resolvedTab = "Invoice Configuration";
    else resolvedTab = "Profile";
    if (!hasValidSubscriptionStatus && !alwaysAllowedTabs.includes(resolvedTab)) {
      setActiveTab("Profile");
      navigate("/settings/profile", { replace: true });
      return;
    }
    setActiveTab(resolvedTab);
  }, [location.pathname, hasValidSubscriptionStatus]);
  const handleBack = () => {
    navigate("/dashboard");
  };

  return (
    <>
      <div className="header-main-container settings-header">
        <img
          alt=""
          src={isDarkMode ? SettingsDarkIcon : SettingsIcon}
          className="settings-icon"
        />
        <h2>Settings</h2>
        <div className="back-to-lookbook">
          <img
            src={ArrowIcon}
            alt="ArrowIcon"
            className="back-icon"
            onClick={handleBack}
          />
          <span onClick={handleBack} className="back-text">
            Back To VybogTAL
          </span>
        </div>
      </div>
      <div className="container">
        <div className="sidebar">
          <div
            className={`tab ${activeTab === "Profile" ? "active" : ""}`}
            onClick={() => navigate("/settings/profile")}
          >
            {isDarkMode ? (
              <img
                src={ProfileDarkIcon}
                alt="ProfileDarkIcon"
                className="account-dark-icons"
              />
            ) : activeTab === "Profile" ? (
              <ProfileActiveIcon />
            ) : (
              <ProfileIcon />
            )}
            Profile
          </div>
          {AdminAccess && (
            <div
              className={`tab ${activeTab === "Subscriptions" ? "active" : ""}`}
              onClick={() => navigate("/settings/subscriptions")}
            >
              {isDarkMode ? (
                <img
                  src={SubscriptionsDarkIcon}
                  alt="SubscriptionsDarkIcon"
                  className="account-dark-icons"
                />
              ) : activeTab === "Subscriptions" ? (
                <SubscriptionsActiveIcon />
              ) : (
                <SubscriptionsIcon />
              )}
              Subscription
            </div>
          )}

          {AdminAccess && hasValidSubscriptionStatus && (
            <div
              className={`tab ${activeTab === "Career Portal" ? "active" : ""}`}
              onClick={() => navigate("/settings/career-portal")}
            >
              <img
                src={
                  isDarkMode
                    ? PublicportLightIcon
                    : activeTab === "Career Portal"
                      ? PublicportActiveIcon
                      : PublicportLightIcon
                }
                alt="Public Careers Portal"
                className="public-portal-tab-icon"
                style={{
                  width: "18px",
                  height: "18px",
                  filter: isDarkMode ? "brightness(0) invert(1)" : "none",
                }}
              />
              Public Careers Portal
            </div>
          )}

          {hasUserPageAccess && hasSubscription && hasValidSubscriptionStatus && (
            <div
              className={`tab ${activeTab === "Users" ? "active" : ""}`}
              onClick={() => navigate("/settings/users")}
            >
              {isDarkMode ? (
                <img
                  src={MembersDarkIcon}
                  alt="MembersDarkIcon"
                  className="account-dark-icons"
                />
              ) : activeTab === "Users" ? (
                <MembersActiveIcon />
              ) : (
                <MembersIcon />
              )}
              Users
            </div>
          )}
          <div
            className={`tab ${activeTab === "Appearance" ? "active" : ""}`}
            onClick={() => navigate("/settings/appearance")}
          >
            {isDarkMode ? (
              <img
                src={AppearanceDarkIcon}
                alt="AppearanceDarkIcon"
                className="account-dark-icons"
              />
            ) : activeTab === "Appearance" ? (
              <AppearanceActiveIcon />
            ) : (
              <AppearanceIcon />
            )}
            Appearance
          </div>
          {AdminAccess && hasValidSubscriptionStatus && (
            <div
              className={`tab ${activeTab === "Customizations" ? "active" : ""}`}
              onClick={() => navigate("/settings/customizations")}
            >
              {isDarkMode ? (
                <img
                  src={integrationDarkIcon}
                  alt="NotificationsDarkIcon"
                  className="account-dark-icons"
                />
              ) : activeTab === "Customizations" ? (
                <IntegrationActiveIcon />
              ) : (
                <IntegrationIcon />
              )}
              Customizations
            </div>
          )}
          {AdminAccess && hasValidSubscriptionStatus && !isHiringTeamTenant &&(
            <div
            className={`tab ${activeTab === "Invoice Configuration" ? "active" : ""}`}
            onClick={() => navigate("/settings/invoice-configuration")}
            >
              {isDarkMode ? (
                <InvoiceConfigDark />
              ) : activeTab === "Invoice Configuration" ? (
                <InvoiceLightIcon />
              ) : (
                <InvoiceDarkIcon />
              )}
              Invoice Configuration
            </div>
          )}
          {AdminAccess && isVendorFeatureEnabled && hasValidSubscriptionStatus && (
            <div
              className={`tab ${activeTab === "Portal Integration" ? "active" : ""}`}
              onClick={() => navigate("/settings/portal-integration")}
            >
              {isDarkMode ? (
                <PortalIntegrationDarkIcon />
              ) : activeTab === "Portal Integration" ? (
                <PortalIntegrationActiveIcon />
              ) : (
                <PortalIntegrationIcon />
              )}
              Portal Integration
            </div>
          )}
          {SuperAdminAccess && hasValidSubscriptionStatus && (
            <div
              className={`tab ${activeTab === "Feedback List" ? "active" : ""}`}
              onClick={() => navigate("/settings/feedback-list")}
            >
              {activeTab === "Feedback List" ? (
                <img
                  src={FeedbackActiveIcon}
                  alt="FeedbackActiveIcon"
                  style={{ width: "22px", height: "22px" }}
                />
              ) : isDarkMode ? (
                <img
                  src={feedbackDarkIcon}
                  alt="feedbackDarkIcon"
                  className="account-dark-icons"
                  style={{ width: "22px", height: "22px" }}
                />
              ) : (
                <FeedbackIcon />
              )}
              Feedback List
            </div>
          )}
        </div>
        <div className={"content-area"}>{renderContent()}</div>
      </div>
    </>
  );
}

export default Settings;